module.exports = "<div class='toggle-wrapper'>\r\n  <img src=\"../../assets/images/Show_dim.png\" alt=\"\" (click)=\"setDimensions()\" class=\"img-dim-toggle\">\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dimensions-toggle/dimensions-toggle.component.html
// module id = ./src/app/dimensions-toggle/dimensions-toggle.component.html
// module chunks = main